import { Controller } from "@hotwired/stimulus"

// This controller can be used on forms that have data-turbo set to false but
// that still want to prevent duplicate form submissions.
export default class extends Controller {
  static targets = ["disableable"]

  disableTargets(event) {
    this.disableableTargets.forEach(element => {
      element.disabled = true

      this.#updateDisableableTargetContent(element, event)
    });
  }

  #submittedByElement(element, event) {
    return element == event.submitter
  }

  #updateDisableableTargetContent(element, event) {
    if (!this.#submittedByElement(element, event)) { return }

    const textContent = element.dataset.textContentWhenDisabledBySelf
    if (textContent == undefined) { return }

    element.textContent = textContent
  }
}
